var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { injectIntl, FormattedMessage } from "@irati/utils/lang";
import { Hr } from "@irati/ui/src/Layout";
import Flex from "@irati/ui/src/Flex";
import { Body } from "@irati/ui/src/Typography";
import appOnly from "@irati/ui/images/app_only.svg";
import { Container, Image } from "./styled";
var AppOnlyImportantInfo = /** @class */ (function (_super) {
    __extends(AppOnlyImportantInfo, _super);
    function AppOnlyImportantInfo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AppOnlyImportantInfo.prototype.render = function () {
        var includeSubHeader = this.props.includeSubHeader;
        return (React.createElement(Container, null,
            React.createElement(Hr, null),
            React.createElement(Flex, { alignItems: "center", marginTop: 2 },
                React.createElement(Image, { src: appOnly }),
                React.createElement(Body, { weight: "bold", margin: [0, 0, 0, 1] },
                    React.createElement(FormattedMessage, { id: "perks.appOnlyImportantInfo.header" }))),
            includeSubHeader && (React.createElement(Body, { small: true, margin: [2, 0] },
                React.createElement(FormattedMessage, { id: "perks.appOnlyImportantInfo.subHeader" })))));
    };
    return AppOnlyImportantInfo;
}(PureComponent));
export default injectIntl(AppOnlyImportantInfo);
